export default "__VITE_ASSET__5bf8e60b__"